import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _FILL_COMMANDS;
import { buildPoly } from './buildPoly.mjs';
export { buildPoly } from './buildPoly.mjs';
import { buildCircle } from './buildCircle.mjs';
export { buildCircle } from './buildCircle.mjs';
import { buildRectangle } from './buildRectangle.mjs';
export { buildRectangle } from './buildRectangle.mjs';
import { buildRoundedRectangle } from './buildRoundedRectangle.mjs';
export { buildRoundedRectangle } from './buildRoundedRectangle.mjs';
export { buildLine } from './buildLine.mjs';
export { ArcUtils } from './ArcUtils.mjs';
export { BezierUtils } from './BezierUtils.mjs';
export { QuadraticUtils } from './QuadraticUtils.mjs';
export { BatchPart } from './BatchPart.mjs';
import { SHAPES } from '@pixi/core';
var FILL_COMMANDS = (_FILL_COMMANDS = {}, _defineProperty(_FILL_COMMANDS, SHAPES.POLY, buildPoly), _defineProperty(_FILL_COMMANDS, SHAPES.CIRC, buildCircle), _defineProperty(_FILL_COMMANDS, SHAPES.ELIP, buildCircle), _defineProperty(_FILL_COMMANDS, SHAPES.RECT, buildRectangle), _defineProperty(_FILL_COMMANDS, SHAPES.RREC, buildRoundedRectangle), _FILL_COMMANDS);
var BATCH_POOL = [];
var DRAW_CALL_POOL = [];
export { BATCH_POOL, DRAW_CALL_POOL, FILL_COMMANDS };